export const builders = {
  28: {
    builderLogo: "/builders/okohazak.png",
    link: "https://www.okohazak.hu/",
  },
  27: {
    builderLogo: "/builders/okohazak.png",
    link: "https://www.okohazak.hu/",
  },
  26: {
    builderLogo: "/builders/hovigo.png",
    link: "https://www.hovigo.hu/",
  },
  25: {
    builderLogo: "/builders/okohazak.png",
    link: "https://www.okohazak.hu/",
  },
  24: {
    builderLogo: "/builders/okohazak.png",
    link: "https://www.okohazak.hu/",
  },
  8: {
    builderLogo: null,
    link: null,
  },
  15: {
    builderLogo: "/builders/simon-otthonok.webp",
    link: "https://www.simonotthonok.hu/",
  },
  17: {
    builderLogo: "/builders/simon-otthonok.webp",
    link: "https://www.simonotthonok.hu/",
  },
  12: {
    builderLogo: "/builders/epitosimon.png",
    link: "https://www.epitosimon.hu/",
  },
  18: {
    builderLogo: "/builders/okohazak.png",
    link: "https://www.okohazak.hu/",
  },
  22: {
    builderLogo: "/builders/okohazak.png",
    link: "https://www.okohazak.hu/",
  },
  21: {
    builderLogo: "/builders/okohazak.png",
    link: "https://www.okohazak.hu/",
  },
  7: {
    builderLogo: "/builders/jasz-residence.svg",
    link: "https://jaszresidence.hu/",
  },
  1: {
    builderLogo: "/builders/hovigo.png",
    link: "https://www.hovigo.hu/",
  },
  23: {
    builderLogo: "/builders/okohazak.png",
    link: "https://www.okohazak.hu/",
  },
  5: {
    builderLogo: "/builders/okohazak.png",
    link: "https://www.okohazak.hu/",
  },
  19: {
    builderLogo: "/builders/okohazak.png",
    link: "https://www.okohazak.hu/",
  },
  10: {
    builderLogo: "/builders/okohazak.png",
    link: "https://www.okohazak.hu/",
  },
  13: {
    builderLogo: null,
    link: null,
  },
  14: {
    builderLogo: null,
    link: null,
  },
}
